import type { ReactNode } from "react";

type FrameProps = {
  caption?: string;
  children: ReactNode;
};

export function Frame({ caption, children }: FrameProps) {
  return (
    <figure className="docs-frame not-prose my-4">
      <div className="docs-frame-inner">
        <div className="docs-frame-grid" aria-hidden="true" />
        <div className="docs-frame-media">{children}</div>
        <div className="docs-frame-ring" aria-hidden="true" />
      </div>
      {caption ? (
        <figcaption className="px-2 pt-2 text-center text-sm text-fd-muted-foreground">
          {caption}
        </figcaption>
      ) : null}
    </figure>
  );
}
